import { el, editable, input } from './domUtils';

export default class MistakesTool {
  static get toolbox() {
    return {
      title: 'Кўп учрайдиган хатолар',
      icon: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    };
  }

  static get sanitize() {
    return { items: { heading: {}, text: {} } };
  }

  constructor({ data }) {
    this.data = { items: data.items?.length ? data.items : [{ heading: '', text: '' }] };
  }

  render() {
    this.list = el('div', { class: 'at-rows' });
    this.data.items.forEach((item) => this.addRow(item));
    const addBtn = el('button', { type: 'button', class: 'at-add-btn', onclick: () => this.addRow({ heading: '', text: '' }) }, ['+ Хато қўшиш']);
    return el('div', { class: 'at-block at-mistakes' }, [
      el('div', { class: 'at-block-label' }, ['Кўп учрайдиган хатолар']),
      this.list,
      addBtn,
    ]);
  }

  addRow(item) {
    const heading = input(item.heading, 'Хато сарлавҳаси...');
    heading.classList.add('at-input-strong');
    const text = editable(item.text, 'Тушунтириш...');
    const removeBtn = el('button', { type: 'button', class: 'at-remove-btn' }, ['×']);
    const row = el('div', { class: 'at-mistake-row' }, [
      el('div', { class: 'at-row' }, [heading, removeBtn]),
      text,
    ]);
    removeBtn.addEventListener('click', () => {
      if (this.list.children.length > 1) row.remove();
    });
    this.list.appendChild(row);
  }

  save() {
    return {
      items: Array.from(this.list.children).map((row) => ({
        heading: row.querySelector('.at-input-strong').value.trim(),
        text: row.querySelector('.at-editable').innerHTML.trim(),
      })).filter((item) => item.heading || item.text),
    };
  }
}
